import { render, staticRenderFns } from "./residence.vue?vue&type=template&id=bf31069e&scoped=true&"
import script from "./residence.vue?vue&type=script&lang=js&"
export * from "./residence.vue?vue&type=script&lang=js&"
import style0 from "./residence.vue?vue&type=style&index=0&id=bf31069e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf31069e",
  null
  
)

export default component.exports